<script>
  import Icon from '@iconify/svelte'

  import { getContext } from 'svelte'

  import ConsentDialog from '~/components/business/consent-dialog/consent-dialog.svelte'
  import LinkButton from '~/components/ui/link-button.svelte'

  let global = getContext('global')

  // prettier-ignore
  /**
   * @type {import("./header.types").SocialItem[]}
   */
  let socials = [
		{ ariaLabel: "Instagram - Criação de sites e softwares personalizados | Lutruvials", anchorTo: "https://www.instagram.com/lutruvials.oficial/", icon: 'ri:instagram-line' },
    { ariaLabel: "Behance - Design profissional | Lutruvials"  , anchorTo: "https://www.behance.net/lutruvials" , icon: 'ri:behance-fill' },
		{ ariaLabel: "Linkedin - Estamos construindo nossa confiança e oportunidades" , anchorTo: "https://www.linkedin.com/company/lutruvials/about",icon: 'ri:linkedin-box-line' },
	];

  // prettier-ignore
  const lists = {
		"x-menu": [{
			title: "Institucional",
			list: [
				{ anchorTo: '/sobre'                   , anchorName: "Sobre nós" },
				{ anchorTo: '/contato'                 , anchorName: "Contato" },
				{ anchorTo: '/'                        , anchorName: "Vagas" },
				{ anchorTo: '/politica-de-privacidade' , anchorName: "Politica de Privacidade" },
			]
		}],

		"x-solutions": [{
			title: 'Soluções',
			list: [
				{ anchorTo: '/', anchorName: 'Desenvolvimento de sistemas sob medida' },
				{ anchorTo: '/', anchorName: 'Desenvolvimento de sites com foco em conversão' },
				{ anchorTo: '/', anchorName: 'Desenvolvimento de E-commerce' },
				{ anchorTo: '/', anchorName: 'Integração e Automação de processos' },
			]
		}],

		"x-contact": [{
			title: 'Contato',
			list: [
				{ icon: 'fa6-solid:phone', anchorName: '+55 (11) 99310-8947', anchorTo: "tel:+5511993108947" },
				{ icon: 'fa6-brands:whatsapp', anchorName: '+55 (11) 99310-8947', anchorTo: "https://wa.me/5511993108947?text=Ol%C3%A1%20gostaria%20de%20ver%20um%20or%C3%A7amento%20sem%20compromisso." },
				{ icon: 'fa6-solid:envelope', anchorName: 'contact@lutruvials.com', anchorTo: "mailto:contact@lutruvials.com" },
			]
		}]
	}
</script>

<footer class="l-footer | min-h-[60vh] bg-black py-[72px] text-white">
  <div class="row-container">
    <div class="l-footer-content | row | mb-8 flex-col justify-between gap-8 md:flex-row">
      <div class="l-footer__group-1">
        <figure>
          <img
            class="mb-4 h-[24px] w-auto md:h-[48px]"
            width="222"
            height="92"
            src="/png/logo-extend-highlight.png"
            alt="Nossa logo traz o estilo de uma empresa especializada e profissional"
          />

          <figcaption class="mb-4 text-sm md:w-5/6">
            A Lutruvials é uma agência de software com foco em soluções flexíveis e projetos
            personalidados para empresas em todo o Brasil.
          </figcaption>
        </figure>
        <ul class="l-footer__socials | row | mb-6 gap-2">
          {#each socials as socialItem}
            <li>
              <a
                class="center | size-[32px] flex-shrink-0 rounded-md bg-gray-100 hover:bg-gray-100 hover:shadow-md"
                href={socialItem.anchorTo || '/'}
                target="_blank"
              >
                <Icon
                  class="size-[24px] text-[24px] leading-[24px] text-brand"
                  icon={socialItem.icon}
                />
                <span class="sr-only">{socialItem.ariaLabel}</span>
              </a>
            </li>
          {/each}
        </ul>

        <a
          class="mb-8 block"
          href="https://www.reclameaqui.com.br/empresa/58-642-077-henrique-santos-santana/"
          target="_blank"
        >
          <img
            src="/png/reclame-aqui.png"
            alt="Lutruvials cadastrada no Reclame Aqui - Consulte nosso perfil"
            width="140"
            height="auto"
          />
        </a>

        <iframe
          title="Nós encontre no Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.80134136374!2d-46.3010698!3d-23.467629299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce7d2d0f9a426b%3A0xaf9a0bb45cec6bf!2sLutruvials%20%7C%20Desenvolvimento%20de%20Software%20%26%20Design%20Gr%C3%A1fico!5e0!3m2!1sen!2sbr!4v1776763638273!5m2!1sen!2sbr"
          width="450"
          height="250"
          style="border:0;"
          class="mb-2.5 w-full rounded-lg lg:w-auto"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

        <div class="l-footer-payments | mb-4">
          <h4 class="mb-2 text-2xl font-bold">Pagamentos</h4>

          <figure class="max-w-[256px]">
            <img
              src="/svg/payments.svg"
              alt="Aceitamos vários tipos de pagamentos, como cartões de crédito e débito, Boleto, Pix. Sendo parcelado em até 12 vezes."
            />
            <figcaption class="sr-only">Aceitamos - Cartões de crédito, Boleto e Pix</figcaption>
          </figure>
        </div>
      </div>

      <div class="l-footer__group-2 | w-full">
        <ul
          class="l-footer__list | row | grow flex-col justify-between gap-8 lg:flex-row lg:gap-[12px]"
        >
          {#each lists['x-contact'] as item}
            <li class="px-3">
              <h4 class="md:text-md mb-4 text-2xl font-medium md:mb-2">{item.title}</h4>
              <ul class="space-y-6 md:space-y-3">
                {#each item.list as childItem}
                  <li class="">
                    <LinkButton
                      size="none"
                      colorPalette="white"
                      variant="plain"
                      class="flex items-center gap-2 whitespace-nowrap text-sm"
                      href={childItem.anchorTo}
                      target="_blank"
                    >
                      <Icon class="size-[18px] text-[18px] leading-[18px]" icon={childItem.icon} />

                      {childItem.anchorName}
                    </LinkButton>
                  </li>
                {/each}

                <li>
                  <address class="font-bold not-italic">
                    08595-360, Parque Macedo - Itaquaquecetuba - São Paulo
                  </address>
                </li>
              </ul>
            </li>
          {/each}

          {#each lists['x-menu'] as item}
            <li class="lg:px-3">
              <h4 class="md:text-md mb-4 text-2xl font-medium md:mb-2">{item.title}</h4>
              <ul class="space-y-6 lg:space-y-3">
                {#each item.list as childItem}
                  <li>
                    <LinkButton
                      size="none"
                      colorPalette="white"
                      variant="plain"
                      class="whitespace-nowrap text-sm"
                      href={childItem.anchorTo}
                    >
                      {childItem.anchorName}
                    </LinkButton>
                  </li>
                {/each}
              </ul>
            </li>
          {/each}

          {#each lists['x-solutions'] as item}
            <li class="lg:px-8">
              <h4 class="md:text-md mb-4 text-2xl font-medium md:mb-2">{item.title}</h4>
              <ul class="space-y-6 md:space-y-3">
                {#each item.list as childItem}
                  <li>
                    <LinkButton
                      size="none"
                      colorPalette="white"
                      variant="plain"
                      class="text-sm"
                      href={childItem.anchorTo}
                    >
                      {childItem.anchorName}
                    </LinkButton>
                  </li>
                {/each}
              </ul>
            </li>
          {/each}
        </ul>
      </div>
    </div>
    <hr />

    <p class="l-footer__copyright | my-3 text-center text-xs sm:text-sm">
      © Copyright CNPJ: 58.642.077/0001-45, 2024 Lutruvials Group. All rights reserved.
    </p>
  </div>
</footer>

<ConsentDialog />
